import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type AddDefaultOnboardingProcessStepsResponse = ClientInferResponseBody<
  typeof contract.onboardingProcessSteps.addDefaults,
  200
>;

export const addDefaultOnboardingProcessStepsApi =
  async (): Promise<AddDefaultOnboardingProcessStepsResponse> => {
    const response = await api.onboardingProcessSteps.addDefaults.mutation({ body: {} });

    if (response.status === 200) {
      return response.body;
    }

    throw new ApiError(
      "Failed to add default onboarding process steps",
      response.status,
      response.body,
    );
  };
